export default {"src":"/_next/static/image/public/images/ic_union.857449c597632b8171b111bb31a860ca.svg","height":15,"width":16};